<template>
      <section class="center md:py-24 py-16 bg-slate-50 dark:bg-slate-800" id="review">
            <div class="container relative">
                <div class="grid grid-cols-1 pb-6 text-center">
                    <h3 class="font-semibold text-2xl leading-normal mb-4">{{ $t('client.1') }}</h3>

                    <p class="text-slate-400 max-w-xl mx-auto">{{ $t('client.2') }}</p>
                </div><!--end grid-->

                <div class="grid grid-cols-1 mt-6">
                    <div class="tiny-three-item">
                        <div v-for="item in clientData" :key="item.index" class="tiny-slide text-center">
                            <div class="cursor-e-resize">
                                <div class="content relative rounded shadow dark:shadow-gray-700 m-2 p-6 bg-white dark:bg-slate-900 before:content-[''] before:absolute before:start-1/2 before:-bottom-[4px] before:box-border before:border-8 before:rotate-[45deg] before:border-t-transparent before:border-e-white dark:before:border-e-slate-900 before:border-b-white dark:before:border-b-slate-900 before:border-s-transparent before:shadow-testi dark:before:shadow-gray-700 before:origin-top-left">
                                    <i class="mdi mdi-format-quote-open mdi-48px text-teal-500"></i>
                                    <p class="text-slate-400">{{item.desc}}</p>
                                   </div>
                                
                                <div class="text-center mt-5">
                                    <img :src="item.image" class="size-14 rounded-full shadow-md dark:shadow-gray-700 mx-auto" alt="">
                                    <h6 class="mt-2 font-semibold">{{item.name}}</h6>
                                    <span class="text-slate-400 text-sm">{{item.title}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';

export default {
    data() {
        return {};
    },
    computed: {
        clientData() {
            return [
                {
                    id: 1,
                    image: require('../assets/images/team/GrzegorzGoc.jpg'),
                    desc: this.$t('client.3'), // Używa dynamicznie tłumaczenia
                    name: 'Grzegorz Goc',
                    title: 'Senior Qt/C++ Developer'
                },
                {
                    id: 2,
                    image: require('../assets/images/team/WojciechSidak.jpg'),
                    desc: this.$t('client.4'),
                    name: 'Wojciech Sidak',
                    title: 'Senior Qt/C++ Developer'
                }
            ];
        }
    },
    mounted() {
        tns({
            container: '.tiny-three-item',
            controls: false,
            mouseDrag: true,
            loop: true,
            rewind: true,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 3000,
            navPosition: "bottom",
            speed: 400,
            gutter: 12,
            responsive: {
                992: { items: 2 },
                767: { items: 2 },
                320: { items: 1 }
            },
        });
    }
};
</script>
